<template>
  <div id="calc-result">
    <div v-if="calc_type" style="text-align:center">
      <v-ons-icon icon="fa-angle-down" size="50px"></v-ons-icon>
    </div>
    <v-ons-list>
      <transition>
        <div id="calc-result-header" v-if="calc_type" key="header">
          <v-ons-list-header>計算結果</v-ons-list-header>
        </div>
      </transition>
      <div id="calc-result-body">
        <transition>
          <div id="display-time-calc-result" key="display-time-calc" v-if="calc_type == 'display-time-calc'">
            <v-ons-list-item class="calc-result-item">
              <div class="calc-result-item-left">
                <span>BPM {{option.bpm_before}} → {{option.bpm_after}}</span>
                <span class="list-item__subtitle">×{{(+option.bpm_after / +option.bpm_before).toFixed(2)}}</span>
              </div>
            </v-ons-list-item>
            <v-ons-list-item class="calc-result-item">
              <span class="calc-result-item-left">開始時の緑数字</span>
              <span class="calc-result-item-right display-time display-time-result">
                {{(+option.display_time * +option.bpm_after / +option.bpm_before).toFixed()}}
              </span>
            </v-ons-list-item>
          </div>
          <div id="fhs-calc-result" key="fhs-calc" v-else-if="calc_type == 'fhs-calc'">
            <v-ons-list-item class="calc-result-item">
              <div class="calc-result-item-left">
                <span>BPM {{option.bpm_before}} → {{option.bpm_after}}</span>
                <span class="list-item__subtitle">×{{(+option.bpm_after / +option.bpm_before).toFixed(2)}}</span>
              </div>
              <span class="calc-result-item-right">BPM × HS</span>
            </v-ons-list-item>
            <v-ons-list-item class="calc-result-item" v-for="result in getFhsCalcResults()">
              <div class="calc-result-item-left">
                <span>HS {{result.hs_before.toFixed(2)}} → {{result.hs_after.toFixed(2)}}</span>
                <span class="list-item__subtitle">{{result.delta}}</span>
              </div>
              <span class="calc-result-item-right">{{result.notes_speed.toFixed()}}</span>
            </v-ons-list-item>
          </div>
          <div id="nhs-calc-result" key="nhs-calc" v-else-if="calc_type == 'nhs-calc'">
            <v-ons-list-item class="calc-result-item">
              <div class="calc-result-item-left">
                <span>BPM {{option.bpm_before}} → {{option.bpm_after}}</span>
                <span class="list-item__subtitle">×{{(+option.bpm_after / +option.bpm_before).toFixed(2)}}</span>
              </div>
              <div class="calc-result-item-right">
                <span class="display-time">緑数字</span>
                <span>BPM × HS</span>
              </div>
            </v-ons-list-item>
            <v-ons-list-item class="calc-result-item" v-for="result in getNhsCalcResults()">
              <div class="calc-result-item-left">
                <span>HS {{result.hs_before.toFixed(2)}} → {{result.hs_after.toFixed(2)}}</span>
                <span class="list-item__subtitle">{{result.delta}}</span>
              </div>
              <div class="calc-result-item-right">
                <span class="display-time">
                  {{result.display_time_before.toFixed()}} → {{result.display_time_after.toFixed()}}
                </span>
                <span>{{result.notes_speed_before.toFixed()}} → {{result.notes_speed_after.toFixed()}}</span>
              </div>
            </v-ons-list-item>
          </div>
          <div id="fhs-to-nhs-calc-result" key="fhs-to-nhs-calc" v-else-if="calc_type == 'fhs-to-nhs-calc'">
            <v-ons-list-item class="calc-result-item">
              <div class="calc-result-item-left">
                <span>BPM {{option.bpm_before}} → {{option.bpm_after}}</span>
                <span class="list-item__subtitle">×{{(+option.bpm_after / +option.bpm_before).toFixed(2)}}</span>
              </div>
              <span class="calc-result-item-right">BPM × HS</span>
            </v-ons-list-item>
            <v-ons-list-item class="calc-result-item" v-for="result in getFhsToNhsCalcResults()">
              <div class="calc-result-item-left">
                <span>HS {{result.hs_before.toFixed(2)}} → {{result.hs_after.toFixed(2)}}</span>
                <span class="list-item__subtitle">FHSからNHSに切り替える</span>
              </div>
              <span class="calc-result-item-right">{{result.notes_speed.toFixed()}}</span>
            </v-ons-list-item>
          </div>
        </transition>
      </div>
    </v-ons-list>
  </div>
</template>

<script>
  import anime from 'animejs'

  const MAX_NOTES_SPEED = 801
  const MAX_NHS_N = 11

  function isInFhsRange (hs) {
    return hs >= 0.5 && hs <= 10.0
  }

  function nhsTable (n) {
    switch (n) {
      case 1:
        return 1.0
      case 2:
        return 1.5
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        return (0.25 * (n - 3)) + 2.0
    }
    return 0
  }

  function fhsToNhsN (fhs) {
    if (fhs < 2.88) {
      if (fhs < 1.76) {
        if (fhs < 1.26) return 1
        else return 2
      } else if (fhs < 2.38) {
        if (fhs < 2.13) return 3
        else return 4
      } else {
        if (fhs < 2.63) return 5
        else return 6
      }
    } else {
      if (fhs < 3.38) {
        if (fhs < 3.13) return 7
        else return 8
      } else if (fhs < 3.88) {
        if (fhs < 3.63) return 9
        else return 10
      } else return 11
    }
  }

  export default {
    props: ['calc_type'],
    data () {
      return {
        option: {
          display_time: '',
          bpm_before: '',
          bpm_after: '',
          adjust_to_bpm_before: false
        }
      }
    },
    updated: function () {
      let newBodyHeight = document.getElementById(this.$props.calc_type + '-result').scrollHeight
      anime({
        targets: '#calc-result-body',
        height: newBodyHeight,
        duration: 500,
        easing: 'easeOutCubic'
      })
      anime({
        targets: '#calc-page',
        scrollTop: 300,
        duration: 500,
        easing: 'easeOutCubic'
      })
    },
    methods: {
      calc: function () {
        this.updateOption()
      },
      getFhsCalcResults: function () {
        let bpmBefore = +this.option.bpm_before
        let bpmAfter = +this.option.bpm_after
        let results = []
        for (let i = 1; i < 21; ++i) {
          let deltaHs = i * 0.5
          let hsBefore = bpmAfter * deltaHs / Math.abs(bpmBefore - bpmAfter)
          let notesSpeed = hsBefore * bpmBefore
          let hsAfter = hsBefore
          let delta = ''
          if (bpmBefore > bpmAfter) {
            hsAfter += deltaHs
            delta = '+' + deltaHs.toFixed(2) + ' (黒鍵' + i + '回)'
          } else {
            hsAfter -= deltaHs
            delta = '-' + deltaHs.toFixed(2) + ' (白鍵' + i + '回)'
          }
          if (notesSpeed < MAX_NOTES_SPEED && isInFhsRange(hsBefore) && isInFhsRange(hsAfter)) {
            results.push({
              delta: delta,
              delta_n: i,
              hs_before: hsBefore,
              hs_after: hsAfter,
              notes_speed: notesSpeed
            })
          }
        }
        return results
      },
      getNhsCalcResults: function () {
        let displayTime = +this.option.display_time
        let bpmBefore = +this.option.bpm_before
        let bpmAfter = +this.option.bpm_after
        let adjustToBpmBefore = this.option.adjust_to_bpm_before
        let results = []
        for (let i = 1; i <= MAX_NHS_N; ++i) {
          let minDeltaNoteSpeed = Number.MAX_VALUE
          let hsBefore = nhsTable(i)
          let notesSpeedBefore = bpmBefore * hsBefore
          let hsAfter, notesSpeedAfter
          let j = 1
          for (; j <= MAX_NHS_N; ++j) {
            hsAfter = nhsTable(j)
            notesSpeedAfter = bpmAfter * hsAfter
            let deltaNoteSpeed = Math.abs(notesSpeedAfter - notesSpeedBefore)
            if (deltaNoteSpeed < minDeltaNoteSpeed) {
              minDeltaNoteSpeed = deltaNoteSpeed
            } else break
          }
          hsAfter = nhsTable(--j)
          notesSpeedAfter = bpmAfter * hsAfter
          let displayTimeBefore = displayTime
          let displayTimeAfter = displayTime

          if (adjustToBpmBefore) {
            displayTimeAfter = displayTime * notesSpeedBefore / notesSpeedAfter
          } else {
            displayTimeBefore = displayTime * notesSpeedAfter / notesSpeedBefore
          }
          let delta = ''
          if (hsBefore < hsAfter) {
            delta = '+' + (hsAfter - hsBefore).toFixed(2) + ' (黒鍵' + (j - i) + '回)'
          } else if (hsBefore > hsAfter) {
            delta = '-' + (hsBefore - hsAfter).toFixed(2) + ' (白鍵' + (i - j) + '回)'
          } else continue
          results.push({
            display_time_before: displayTimeBefore,
            display_time_after: displayTimeAfter,
            hs_before: hsBefore,
            hs_after: hsAfter,
            notes_speed_before: notesSpeedBefore,
            notes_speed_after: notesSpeedAfter,
            delta: delta
          })
        }
        return results
      },
      getFhsToNhsCalcResults: function () {
        let bpmBefore = +this.option.bpm_before
        let bpmAfter = +this.option.bpm_after
        let results = []
        for (let i = 1; i <= MAX_NHS_N; ++i) {
          let nhs = nhsTable(i)
          let fhs = nhs * bpmAfter / bpmBefore
          let notesSpeed = bpmAfter * nhs
          if (fhsToNhsN(fhs) === i && isInFhsRange(fhs) && notesSpeed < MAX_NOTES_SPEED) {
            results.push({
              hs_before: fhs,
              hs_after: nhs,
              notes_speed: notesSpeed
            })
          }
        }
        return results
      },
      updateOption: function () {
        this.option.display_time = localStorage.getItem('display-time')
        this.option.bpm_before = localStorage.getItem('bpm-before')
        this.option.bpm_after = localStorage.getItem('bpm-after')
        this.option.adjust_to_bpm_before = Boolean(+localStorage.getItem('adjust-to-bpm-before'))
      }
    }
  }
</script>

<style scoped>
  #calc-result {
    margin-bottom: 30px;
  }

  .display-time-result {
    font-size: 30px;
  }

  .display-time {
    color: green;
  }

  .fa-angle-down {
    transform: scale(2.5, 1);
    color: gray;
  }

  #calc-result-body {
    position: relative;
  }

  #calc-result-body > ons-list-item {
    position: absolute;
    top: 0;
    left: 0;
  }

  .calc-result-item-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 59%;

    /*border-right: 1px solid lightgrey;*/
  }

  .calc-result-item-left .list-item__subtitle {
    align-self: center !important;
  }

  .calc-result-item-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40%;
  }

  .calc-result-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-enter-active {
    transition: opacity .5s
  }

  .v-enter {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/CalcResult.vue